<template>
    <div class="modal-input">
        <div class="head flex-row flex-between items-start">
            <div class="title" :class="titleClass" v-html="$translate(title)" />
            <span class="time" v-if="timeLeft"
                >남은시간 <span class="time-left">{{ timeLeft }}</span></span
            >
        </div>
        <div v-if="inputs" class="inputs">
            <div class="form-control" :key="idx" v-for="(input, idx) in inputs">
                <label v-html="$translate(input.label)" />
                <input
                    :class="`modal-input-${idx}`"
                    :data-idx="`${idx}`"
                    v-if="input.type !== 'textarea'"
                    @input="input.text = inputChecker($event.target.value)"
                    :value="input.text"
                    :placeholder="$translate(input.placeholder)"
                />
                <textarea
                    v-else
                    @input="input.text = inputChecker($event.target.value)"
                    :value="input.text"
                    :placeholder="$translate(input.placeholder)"
                />
            </div>
        </div>

        <div class="buttons">
            <button @click="onSave" class="btn btn-warning" v-html="'저장하기'" />
            <div class="right-button">
                <button @click="$emit('close')" class="btn btn-default" v-html="$translate('CANCEL')" />
                <button
                    @click="onClick"
                    class="btn"
                    :class="this.isNotNull ? 'btn-primary' : 'btn-primary-off'"
                    v-html="buttons ? $translate(buttons) : $translate('SEND')"
                />
            </div>
        </div>
    </div>
</template>
<script>
import agentService from '@/services/agent'

export default {
    name: 'ModalSendSMS',
    props: ['options'],
    data: () => ({
        isNotNull: false,
    }),
    computed: {
        title() {
            return (this.options || {}).title
        },
        titleClass() {
            return (this.options || {}).titleClass
        },
        inputs() {
            return (this.options || {}).inputs || []
        },
        buttons() {
            return (this.options || {}).buttons
        },
        error() {
            return (this.options || {}).error
        },
        timeLeft() {
            const now = this.$moment()
            const sent = this.$moment(this.options.sentDate)
            console.log('sent', sent.format('YY-MM-DD hh:mm'))
            const canSend = this.options.sentDate ? sent.add(1, 'days') : false
            if (canSend && canSend.isAfter(now)) {
                const duration = this.$moment.duration(canSend.diff(now))
                return `${duration.get('hours')} : ${duration.get('minutes')}`
            } else {
                return null
            }
        },
    },
    mounted() {
        document.addEventListener('keydown', this.onKeydown)
        this.$nextTick(_ => {
            const dom = document.getElementsByClassName('modal-input-0')
            if (dom && dom.length > 0) {
                dom[0].focus()
            }
        })
        this.options.inputs.forEach(input => this.inputChecker(input.text))
    },
    beforeDestroy() {
        document.removeEventListener('keydown', this.onKeydown)
    },
    methods: {
        onClickButton(btn) {
            if (this.isNotNull) {
                this.$emit('close', this.inputs)
            } else {
                this.$toast.error(this.$translate(this.error))
            }
        },
        onKeydown(event) {
            const idx = event.target.dataset.idx
            if (event.key === 'Enter' && this.options.preventSubmit) {
                this.inputs[idx] = this.inputs[idx] + '\n'
            } else if (event.key === 'Enter' && this.inputs) {
                const confirmButton = this.inputs[this.inputs.length - 1]
                if (confirmButton) this.onClickButton(confirmButton)
            }
        },
        inputChecker(inputText) {
            if (inputText.length === 0) {
                this.isNotNull = false
            } else {
                this.isNotNull = true
            }

            return inputText
        },
        onClick() {
            if (this.isNotNull) {
                this.$emit('close', this.inputs)
            } else {
                this.$toast.error(this.$translate(this.error) || '값을 입력해주세요')
            }
        },
        async onSave() {
            try {
                this.$loading(true)
                const agent = this.$store.getters.agent
                console.log(agent)
                agent.sms_content = this.inputs[0].text

                await agentService.update(agent)
            } finally {
                this.$loading(false)
                this.$toast.success('SMS 자동텍스트가 저장되었습니다')
            }
        },
    },
}
</script>
<style scoped lang="scss">
.time {
    font-size: 14px;
    line-height: 24px;
    display: flex;
    align-items: center;
    .time-left {
        margin-left: 10px;
        font-size: 20px;
        line-height: 24px;
        font-weight: 700;
    }
}
.btn {
    min-width: 60p;
    width: fit-content;
}
.buttons {
    display: flex;
    justify-content: space-between;
    .right-button {
        display: flex;
    }
}
</style>
